import React from 'react';
import { LifeBuoy, Heart, AlertTriangle, Loader2 } from 'lucide-react';
import { Card, Btn, Empty } from './shared';

const RecoveryCard = ({ rp, onGenerate, generating, canGenerate }) => (
  <Card
    title="Recovery & Physio" icon={LifeBuoy}
    action={(
      <Btn variant="secondary" onClick={onGenerate} disabled={!canGenerate || generating}>
        {generating && <Loader2 className="w-4 h-4 animate-spin" />}
        {rp ? 'Regenerate' : 'Generate session'}
      </Btn>
    )}
  >
    {!rp ? (
      <Empty>A separate physio-led session shaped by your injuries and recovery score.</Empty>
    ) : (
      <div className="space-y-4">
        <p className="text-[#d3d8e0] text-sm leading-relaxed">{rp.summary}</p>

        {Array.isArray(rp.items) && rp.items.length > 0 && (
          <ul className="divide-y divide-[#1f2937] border border-[#1f2937] rounded-lg overflow-hidden">
            {rp.items.map((it, i) => (
              <li key={i} className="px-3 py-2.5 bg-[#0b0c10]">
                <div className="flex items-baseline justify-between gap-3 flex-wrap">
                  <span className="text-white font-semibold text-sm">{it.name}</span>
                  <span className="text-[#ff7a1a] text-xs font-bold">{it.duration}</span>
                </div>
                {it.target_area && <p className="text-[#7c8597] text-[10px] uppercase tracking-wider mt-0.5">{it.target_area}</p>}
                {it.notes && <p className="text-[#aab1bf] text-xs mt-1 leading-relaxed">{it.notes}</p>}
              </li>
            ))}
          </ul>
        )}

        {Array.isArray(rp.physio_cues) && rp.physio_cues.length > 0 && (
          <div className="rounded-lg border border-[#1f2937] p-3 bg-[#0b0c10]">
            <p className="text-[#ff7a1a] font-bold text-[10px] uppercase tracking-wide flex items-center gap-1.5">
              <Heart className="w-3.5 h-3.5" /> Physio cues
            </p>
            <ul className="mt-2 space-y-1.5">
              {rp.physio_cues.map((c, i) => (
                <li key={i} className="text-[#d3d8e0] text-sm leading-snug flex gap-2">
                  <span className="text-[#ff7a1a]">•</span><span>{c}</span>
                </li>
              ))}
            </ul>
          </div>
        )}

        {Array.isArray(rp.red_flags) && rp.red_flags.length > 0 && (
          <div className="rounded-lg border border-[#3a2310] bg-[#1a0f06]/60 p-3">
            <p className="text-[#ff7a1a] font-bold text-[10px] uppercase tracking-wide flex items-center gap-1.5">
              <AlertTriangle className="w-3.5 h-3.5" /> Stop & see a clinician if
            </p>
            <ul className="mt-2 space-y-1.5">
              {rp.red_flags.map((c, i) => (
                <li key={i} className="text-[#cbb39a] text-xs leading-snug flex gap-2">
                  <span className="text-[#ff7a1a]">•</span><span>{c}</span>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    )}
  </Card>
);

export default RecoveryCard;
